import {
  renderSectionHeader,
  renderRowGaps,
  renderColumnGaps,
  renderMainLeftCell,
  renderMainRightCell
} from '../helpers';

export const renderHeaderRow = () => {
  const headers = [
    'Years of Experience with Fund',
    'Years of Experience with Capital Group',
    'Years of Experience with Investment Industry'
  ];
  let headerRow = `<tr>`;
  headerRow += renderColumnGaps(1);
  headers.forEach(header => {
    headerRow += renderMainLeftCell(header);
  });
  headerRow += `</tr>`;
  return headerRow;
};

export const renderManagerRow = manager => {
  let managerRow = ``;
  if (manager) {
    managerRow += `<tr>`;
    managerRow += renderMainLeftCell(manager.displayName);
    managerRow += renderMainRightCell(manager.fundExperience);
    managerRow += renderMainRightCell(manager.cgExperience);
    managerRow += renderMainRightCell(manager.industryExperience);
    managerRow += `</tr>`;
  }
  return managerRow;
};

export const portfolioManagementModule = (portfolioManagement, title) => {
  let managementText = ``;
  managementText += renderSectionHeader(title);
  managementText += renderHeaderRow();
  managementText += renderRowGaps(1);
  for (const manager of portfolioManagement.managers) {
    managementText += renderManagerRow(manager);
  }
  managementText += renderRowGaps(2);
  return managementText;
};

